module.exports = __webpack_public_path__ + "media/images/bar_graph-91a951b75cafd61bb1d3e8d4b09c9c0e.svg";